export default defineAppConfig({
  ui: {
    icons: {
      dynamic: true,
    },
    primary: 'p',

    button: {
      base: 'group duration-150',
      rounded: 'rounded-full',
      variant: {
        solid: 'text-slate-950 bg-{color}-600 hover:bg-{color}-500 text-white',
        link: 'text-{color}-600 hover:text-{color}-900 disabled:text-{color}-700 dark:text-{color}-300 dark:hover:text-{color}-400 dark:disabled:text-{color}-400 underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
        outline: 'ring-1 ring-inset ring-current text-{color}-700 dark:text-{color}-400 hover:bg-{color}-50 disabled:bg-transparent dark:hover:bg-{color}-950 dark:disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-{color}-700 dark:focus-visible:ring-{color}-400',
        soft: 'text-{color}-700 bg-{color}-100  hover:ring-{color}-700 disabled:bg-{color}-50 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 hover:bg-{color}-200',
        ghost: 'text-{color}-700 dark:text-{color}-400 hover:bg-{color}-50 disabled:bg-transparent  focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
      },
      defaults: {
        icon: 'heroicons:chevron-right-20-solid',
      },
      size: {
        '2xl': 'text-lg lg:text-2xl xl:text-3xl',
        '3xl': 'text-xl xl:text-2xl font-semibold tracking-wide',
        '1.5xl': 'text-lg xl:text-xl px-8 py-5 gap-6',
      },
      gap: {
        '2xl': 'gap-x-3',
        '3xl': 'gap-x-4',
      },
      padding: {
        '3xl': 'px-6 lg:px-10 py-3 lg:py-4',
      },
      color: {
        red: { solid: 'bg-red-600 hover:bg-red-700 text-white' },
        pink: { solid: 'bg-pink hover:bg-blue text-white' },
        yellow: { solid: 'bg-yellow text-white hover:bg-pink' },
        lightblue: { solid: 'bg-lightblue hover:bg-blue text-white' },
        blue: { solid: 'bg-blue hover:bg-primary-900 text-white' },
        white: { solid: 'bg-white !text-blue hover:!bg-blue hover:!text-white !ring-transparent' },
        pinkblue: { solid: 'bg-pink text-white hover:!bg-lightblue !ring-transparent' },
      },
      icon: {
        size: {
          '3xl': 'h-10 w-10',
        },
      },

    },
    input: {
      variant: {
        editor: 'rounded-md disabled:opacity-75 focus:outline-none border-0 form-input placeholder-gray-400 dark:placeholder-gray-500 text-sm px-2.5 py-1.5 shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400',
      },
      rounded: 'rounded-full',
      size: {
        '2xl': 'text-base md:text-lg xl:text-xl',
      },
      gap: {
        '2xl': 'gap-x-3',
      },
      padding: {
        '2xl': 'px-6 py-4',
      },
      leading: {
        padding: {
          '2xl': 'ps-12',
        },
      },
      trailing: {
        padding: {
          'xl': 'pe-2',
          '2xl': 'pe-2',
        },
      },
      icon: {
        size: {
          '2xl': 'h-6 w-6',
        },
        leading: {
          padding: {
            '2xl': 'px-4',
          },
        },
        trailing: {
          padding: {
            '2xl': 'px-4',
          },
        },
      },
    },
    textarea: {
      variant: {
        editor: 'rounded-md disabled:opacity-75 focus:outline-none border-0 form-input placeholder-gray-400 dark:placeholder-gray-500 text-sm px-2.5 py-1.5 shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400',
      },
    },
    table: {
      th: {
        base: 'capitalize',

      },
      default: {
        sortAscIcon: 'heroicons:bars-arrow-up-20-solid',
        sortDescIcon: 'heroicons:bars-arrow-down-20-solid',
        sortButton: {
          icon: 'heroicons:arrows-up-down-20-solid',
          trailing: true,
          square: true,
          color: 'gray',
          variant: 'ghost',
          class: '-m-1.5 !capitalize',
        },
      },
    },
  },
})
